import React from 'react';
import './style.scss';
import { connect } from 'react-redux';

import { fetch_conversation } from '../redux/Conversations/actions';
import TopNavBar from '../containers/navs/TopNavBar';
import Sidebar from '../containers/navs/Sidebar';

class index extends React.Component {
  componentWillMount() {
    this.props.fetch_conversation({ page: 1, rowsPerPage: 1000 });
  }
  render() {
    window.Notification.requestPermission();
    return (
      <div className="ut-admin-layout">
        <TopNavBar />
        <div className="ut-admin-menu">
          <Sidebar />
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  //
});

export default connect(mapStateToProps, { fetch_conversation })(index);
